import { cloneDeep } from "lodash";
import { api } from "services";

import { IS_DEV } from "globals/constants";
import { subaward as constants } from "store/constants";
import { actionLoaderFactory } from "store/factories/fetchable";
import { dispatch } from "store/store";
import { fetchSubaward, notifyError } from "utils";
import { prepareSingleEntityValues, updateEntityOrProperty, updateEntityAdminTeamMembers } from "utils/entityHelpers";

import { subawardSelectors } from "../selectors";
import { setFormEntityData } from "./form";
import { fetchCurrentProjectAccess } from "./userAccesses";


const factory = actionLoaderFactory(constants, constants.SINGLE_SUBAWARD);
const valuesFactory = actionLoaderFactory(constants, constants.SINGLE_SUBAWARD_VALUES);

export const setSubawardData = factory.setData;

export const resetSubaward = () => dispatch({ type: constants.RESET });

export const getSubaward = (subawardId, options = { isRefresh: false }) => {
	return factory.createLoaderAction(
		() => fetchSubaward(subawardId),
		[
			async (response) => {
				factory.setData({ subaward: response });
				setFormEntityData({ editLock: response.editLock });
				fetchCurrentProjectAccess("subaward");

				return response;
			},
			(error, { getState }) => {
				const message = IS_DEV ? error.message : getState().dictionary.subawards.errors.subawardFailedLoad;

				notifyError(message, error);
				factory.setError(message);
			},
		],
		options,
	);
};

export const getSubawardValues = ({ awardId, subawardId }) => {
	return valuesFactory.createLoaderAction(
		() => api.subaward.getValues(awardId, subawardId),
		[
			response => {
				const values = prepareSingleEntityValues(response);

				valuesFactory.setData(values);

				return values;
			},
			(error, { getState }) => {
				const message = IS_DEV ? error.message : getState().dictionary.subawards.errors.subawardFailedLoad;

				notifyError(message, error);
				valuesFactory.setError(message);
			},
		],
	);
};


export const updateAwardAdminTeamMembers = idAdminTeamMemberArray => {
	const subaward = updateEntityAdminTeamMembers(idAdminTeamMemberArray, cloneDeep(subawardSelectors.subaward()));

	factory.setData({ subaward });
};

export const updateSubawardOrProperty = (value, property = "") => {
	const subaward = updateEntityOrProperty(subawardSelectors.subaward())(value, property);

	factory.setData({ subaward });

	return subaward;
};
